import classnames from "classnames";
import parse from "html-react-parser";
import React from "react";

import { Text } from "@krea/customer-features/shared-components/text";

const FreeTextParser = ({ text }) => {
  const htmlParserOptions = {
    trim: true,
    replace: (domNode) => {
      if (domNode.type && domNode.type === "text") {
        return (
          <Text
            className={classnames({
              "mb-2 font-weight-bold": domNode.next,
              "mt-2": !domNode.prev && domNode.next,
              "mb-0": !domNode.next,
            })}
          >
            {domNode.data}
          </Text>
        );
      }

      if (domNode.name === "br") {
        return <></>;
      }
    },
  };

  return parse(text.replace(/(\r\n|\n|\r)/gm, "<br />"), htmlParserOptions);
};

export default FreeTextParser;
